export enum NoknoNotificationTypes {
  AssetCreated = 'asset_created',
}

export interface NoknoNotification {
  subject: NoknoNotificationTypes;
  payload: any;
}